// Brand configuration — Azeka master mark derived into Global (no tagline) and Health (with tagline) lockups.
export const BRAND = {
  global: {
    name: "Azeka Global Trade FZCO",
    short: "Azeka Global",
    logoOnDark: "/azeka-global-white.png",
    logoOnLight: "/azeka-global-navy.png",
    icon: "/azeka-icon.png",
    iconWhite: "/azeka-icon-white.png",
    domain: "azekaglobal.com",
  },
  health: {
    name: "Azeka Health",
    short: "Azeka Health",
    tagline: "Pure Wellbeing",
    logo: "/azeka-health.png",
    icon: "/azeka-icon.png",
    domain: "azekahealth.com",
  },
};
